import { Component, OnInit } from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {AbstractControl, FormControl, FormGroup, ValidationErrors} from '@angular/forms';

@Component({
  selector: 'app-firma-documentos-atajo-modal',
  templateUrl: './firma-documentos-atajo-modal.component.html',
  styleUrls: ['./firma-documentos-atajo-modal.component.css']
})
export class FirmaDocumentosAtajoModalComponent implements OnInit {

  firmaDocumentosForm: FormGroup;
  constructor(public dialogRef: MatDialogRef<FirmaDocumentosAtajoModalComponent>) { }

  ngOnInit(): void {
    this.initForm();
  }

  initForm(): void {
    this.firmaDocumentosForm = new FormGroup({
      mandato: new FormControl(false),
      poder: new FormControl(false),
      tramiteRelacionado: new FormControl('', { validators: [this.requiredValidator] }),
      numPedido: new FormControl('')
    }, { validators: [this.atLeastOneCheckbox] });
  }

  atLeastOneCheckbox(group: AbstractControl): ValidationErrors | null {
    const mandato = group.get('mandato').value;
    const poder = group.get('poder').value;
    return mandato || poder ? null : { atLeastOne: true };
  }

  requiredValidator(control: AbstractControl): ValidationErrors | null {
    return control.value ? null : { required: true };
  }
}
